export const ENUMERATION = 'enum';
export const OBJECT = 'object';
export const TEXT = 'text';
export const NUMBER = 'number';

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];
export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_ROWS = [];
export const DEFAULT_COLUMNS = [];
export const DEFAULT_DATA = [];

export const NO_VALUE = '(Empty)';
